enum TruckerAway {
  MAX_VALUE = 205,
  MIN_VALUE = 5,
  INITIAL_VALUE = 50,
  STEP_VALUE = 50,
  FIFTY_VALUE = 55,
  ONE_HUNDRED_VALUE = 105,
  ONE_HUNDRED_FIFTY_VALUE = 155,
}

export { TruckerAway };
